<template>
    <div class="ipoint">
        <p class="remaining">{{$t('user_center_iPoint_Remaining')}}: {{ipointCount}}</p>
        <div class="tabs tabs-ipoint">
            <topUp></topUp>
        </div>
    </div>
</template>

<script>
    import topUp from './iPoint/TopUp.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                tabs: [
                    {name: 'Top Up', components: 'topUp'},
                    {name: 'Transfer', components: 'transfer'}
                ],
                currentTab: 'topUp',
                flag: 0,
                userinfo: [],
                ipointCount: ''
            }
        },
        components: {
            topUp
        },
        methods: {
            toggleTab: function (tab, index) {
                this.currentTab = tab
                this.flag = index
            },
            updateUserPoints (points) {
                let userinfo = this.Local.get('users')
                userinfo.user_info.ipoint = points
                this.Local.unset('users')
                this.Local.set('users', userinfo)
            }
        },
        created () {
            let module = 'index.php/index/user/info'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            this.$http.get(process.env.BASEURL + module, {
                params: data
            }).then(function (response) {
                if (parseInt(response.data.code) === 2000) {
                    this.userinfo = response.data.data
                    this.ipointCount = response.data.data.userinfo.ipoint
                    this.updateUserPoints(this.ipointCount)
                }
            }.bind(this))
        }
    }
</script>

<style lang="scss">

    .ipoint {
        padding: 30px;
        .remaining {
            font-size: 24px;
            color:#0084FF;
            font-weight: 600;
        }
    }

    .tabs-ipoint {
        text-align: center;
        .order-tab-inline > li {
            padding: 0 100px;
        }
    }

    @media (max-width: 920px) {
        .ipoint {
            padding: 5px;
        }
        .tabs-ipoint .order-tab-inline > li {
            padding: inherit;
        }
    }

</style>



// WEBPACK FOOTER //
// iPoint.vue?38754c38